import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { NProgress } from '../util/nprogress';
import commons from '../util/commons';
import store from '../store/store';
import * as types from '../store/types';

Vue.use(VueRouter);
// 引入加载条
const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes,
});
router.beforeEach((to, from, next) => {
  NProgress.configure({ parent: 'body' });
  if (to.meta.NProgress) {
    // NProgress.start();
  }
  const localUser = commons.readTodos('localUser');
  // 如果需要登陆
  if (to.meta.requireAuth) {
    // 如果没有登录
    if (!localUser.token) {
      // 未登录则跳转登陆页面
      next({ path: '/login' });
    } else {
      // 如果登陆了
      const overTimes = localUser.startTimes + localUser.overTimes;
      // 如果当前时间超過过期时间
      if (Date.parse(new Date()) > overTimes) {
        next({ path: '/login', query: { k: localUser.k } });
        // console.log(localUser, '====================================');
      } else {
        // 判断是否拥有权限
        // eslint-disable-next-line no-lonely-if
        if (to.meta.rbacNode && !(store.getters[types.GET_LOCALUSER].node).includes(to.meta.rbacNode)) {
          next({ path: '/home' });
          next();
        } else {
          next();
        }
      }
    }
  } else {
    next();
  }
});
router.afterEach(() => {
  // NProgress.done();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js